import { joinURL } from 'ufo'
import type { NuxtError } from '#app'
import type { Ref } from 'vue'
import type {
  NewsArticle,
  SearchArticle,
} from '../../../server/models/news/news-article'

interface UseArticle {
  article: Ref<NewsArticle | SearchArticle | null>
  pending: Ref<boolean>
  error: Ref<NuxtError<unknown> | null>
}

export const useArticle = async (articleId: string): Promise<UseArticle> => {
  const { data, pending, error } = await useAsyncData<
    NewsArticle | SearchArticle
  >('articles', () =>
    $fetch<NewsArticle | SearchArticle>(
      joinURL('/api/v2/news/article', articleId),
      {
        timeout: 5000,
        retry: 0,
      }
    )
  )

  return {
    article: data,
    pending,
    error,
  }
}
